import * as React from 'react';
import { observer } from 'mobx-react';
import { DangerAlert } from 'ui-lib';
import devicesCss from './devices.css';
import { DeviceCryptoReportStore } from '../../../../../store/device-details/device-crypto-report-store';
import { IDeviceTableProps } from './components';
import { useDeviceStore } from 'store';

export const DeviceCryptoReportComponent = observer((props: IDeviceTableProps) => {
    const devicesStore = useDeviceStore();
    const memoizedStore = React.useMemo(() => {
        const store = new DeviceCryptoReportStore({
            accountId: props.accountId,
            uid: props.uid,
            devicesStore: devicesStore,
            serialNumber: props.serialNumber,
        });
        store.initialize();
        return store;
    }, []);

    return (
        <div className={devicesCss.tabPane}>
            {memoizedStore.error != undefined && (
                <DangerAlert closable={false} message='Error' description={memoizedStore.error} />
            )}
            <pre>{memoizedStore.loading ? 'Loading the report......' : memoizedStore.displayCryptoReport}</pre>
        </div>
    );
});
